import { Box, Typography, Grid, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import data from "../../Assets/data/books.json";

const BooksPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const bookUrl = pathname.split("/")[location.pathname.split("/").length - 1];
  const currentBook = data.find((book) => {
    return book.url === bookUrl ? book : null;
  });
  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "2em",
      }}
    >
      <Box
        style={{
          width: "100%",
          background:
            "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
        }}
      >
        <Typography
          style={{
            padding: "32px",
            width: "100%",
            justifyContent: "flex-end",
            display: "flex",
            boxSizing: "border-box",
            marginRight: "32px",
          }}
          fontSize="32px"
          fontWeight={600}
          textAlign="right"
        >
          {currentBook.title}
        </Typography>
      </Box>
      <Box
        style={{
          maxWidth: "960px",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container>
          <Grid xs={3} item>
            <Box>
              <Typography
                style={{ margin: "24px 0px" }}
                fontSize="28px"
                fontWeight={600}
              >
                DIRECTORY
              </Typography>
            </Box>
            <Box>
              <Button
                style={{ textTransform: "none", padding: "0px" }}
                onClick={() => navigate("/publications/books")}
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Back to Books
                </Typography>
              </Button>
              <Button
                style={{ textTransform: "none", padding: "0px" }}
                onClick={() => navigate("/publications")}
              >
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Back to Publications
                </Typography>
              </Button>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              style={{
                display: "flex",
                padding: "16px",
                flexDirection: "column",
              }}
            >
              {/* <AspectRatio ratio="9/16"> */}
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/Images/BookCover/" +
                  currentBook.image
                }
                alt="book cover"
                style={{
                  width: "-webkit-fill-available",
                  maxWidth: "360px",
                }}
              />
              {/* </AspectRatio> */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  padding: "16px",
                  boxSizing: "border-box",
                }}
              >
                <Typography>
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Title:{" "}
                  </span>
                  {currentBook.title}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Author:{" "}
                  </span>
                  {currentBook.author}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Year:{" "}
                  </span>
                  {currentBook.year}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Publisher:{" "}
                  </span>
                  {currentBook.publisher}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            xs={5}
            item
            style={{
              padding: "16px",
              marginBottom: "16px",
              paddingTop: "0px",
            }}
          >
            <Typography textAlign="justify">
              {currentBook.description
                ? currentBook.description
                : "No description"}
            </Typography>
          </Grid>
          <Grid xs={3} item></Grid>
          <Grid xs={9} item>
            {currentBook.reviews.map((review, i) => {
              return (
                <Box style={{ marginBottom: "48px" }} key={i}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "48px",
                    }}
                  >
                    <div
                      style={{
                        width: "80%",
                        height: "2px",
                        background: "rgba(0,0,0,0.1)",
                      }}
                    />
                  </div>
                  <Typography
                    marginBottom="24px"
                    textAlign="center"
                    fontStyle="italic"
                  >
                    {review.review}
                  </Typography>
                  <Typography textAlign="center">
                    {`- `}
                    <span style={{ fontWeight: 800 }}>
                      {review.reviewer.name}
                    </span>
                    {`${
                      review.reviewer.role ? ", " + review.reviewer.role : ""
                    }${
                      review.reviewer.affiliation
                        ? ", " + review.reviewer.affiliation
                        : ""
                    }`}
                  </Typography>
                  {i === currentBook.reviews.length - 1 ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "48px",
                      }}
                    >
                      <div
                        style={{
                          width: "80%",
                          height: "2px",
                          background: "rgba(0,0,0,0.1)",
                        }}
                      />
                    </div>
                  ) : null}
                </Box>
              );
            })}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
export default BooksPage;
